import { Layout, Space, Typography } from "antd";
import Sider from "antd/lib/layout/Sider";
import { Content, Header } from "antd/lib/layout/layout";
import React from "react";
import { Link } from "react-router-dom";
import color from "../../../theme/color";
import { OriginalLogo } from "../Icon";
import Menus from "./Menus";
import { OutLinkMenu } from "./Menus/OutLink";
import UserInfo from "./UserInfo";

interface Props {}

const LayoutForm: React.FC<Props> = ({ children }) => {
  return (
    <Layout
      style={{
        width: "100vw",
        height: "100vh",
        overflow: "hidden",
      }}
      hasSider
    >
      <Sider
        style={{
          overflow: "auto",
          height: "100vh",
          flex: "auto",
          borderRight: `1px solid ${color.gray9}`,
        }}
        width={210}
      >
        <Link to="/">
          <Space
            size={4}
            style={{
              display: "inline-flex",
              padding: "16px 20px",
              width: "100%",
              borderBottom: `1px solid ${color.gray9}`,
            }}
            align="center"
          >
            <picture style={{ display: "flex" }}>
              <OriginalLogo height={16} width={121} />
            </picture>
            <Typography.Text
              strong
              style={{
                color: color.gray2,
                fontSize: 16,
                lineHeight: "24px",
              }}
            >
              Crew
            </Typography.Text>
          </Space>
        </Link>
        <Menus />
        <OutLinkMenu />
      </Sider>
      <Layout>
        <Header
          style={{
            position: "sticky",
            right: 0,
            height: 57,
            padding: "12px 24px",
            borderBottom: `1px solid ${color.gray9}`,
            display: "inline-flex",
            justifyContent: "end",
          }}
        >
          <UserInfo />
        </Header>
        <Content
          style={{
            position: "sticky",
            overflow: "auto",
          }}
        >
          {children}
        </Content>
      </Layout>
    </Layout>
  );
};

export default LayoutForm;
